function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  left: ",
        ";\n  transition: left ",
        ";\n  z-index: 100;\n  width: 100%;\n  height: 52px;\n  padding: 10px ",
        ";\n  background-color: rgba(255, 255, 255, 0.9);\n  border-top: 1px solid #e8e8e8;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React from "react";
import { Space } from "antd";
import styled from "styled-components";
import { SIDE_NAV_PROPERTY, SIDE_NAV_TRANSITION_CURVE } from "../hooks/useSideNavExpanded";
var Wrap = styled.div(_templateObject(), function(props) {
    return props.$fullWidth ? "0" : "var(".concat(SIDE_NAV_PROPERTY, ")");
}, SIDE_NAV_TRANSITION_CURVE, function(props) {
    return props.$fullWidth ? "45px" : props.$paddingLeft;
});
var StickyFooter = function(param) {
    var children = param.children, _param_fullWidth = param.fullWidth, fullWidth = _param_fullWidth === void 0 ? false : _param_fullWidth, _param_paddingLeft = param.paddingLeft, paddingLeft = _param_paddingLeft === void 0 ? "58px" : _param_paddingLeft;
    return /*#__PURE__*/ React.createElement(Wrap, {
        $fullWidth: fullWidth,
        $paddingLeft: paddingLeft
    }, /*#__PURE__*/ React.createElement(Space, null, children));
};
export default StickyFooter;
